import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import rootReducer from './reducers';

export default function configureStore(api) {
  const middlewares = [thunk.withExtraArgument(api)];
  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger);
  }

  const initialState = {};
  const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middlewares),
  );

  return store;
}
